import $ from 'jquery';
import bodymovin from './lottie.min';
import Global from './global';

export default () => {

  // converts SVG coords to screen coords respecting the scroll position
  function svgToScreen(el) {
    let found;
    let left = 0;
    let top = 0;
    let width = 0;
    let height = 0;
    let offsetBase = svgToScreen.offsetBase;
    if (!offsetBase && document.body) {
      offsetBase = svgToScreen.offsetBase = document.createElement('div');
      offsetBase.style.cssText = 'position:absolute;left:0;top:0';
      document.body.appendChild(offsetBase);
    }
    if (el && el.ownerDocument === document && 'getBoundingClientRect' in el && offsetBase) {
      const boundingRect = el.getBoundingClientRect();
      const baseRect = offsetBase.getBoundingClientRect();
      found = true;
      left = boundingRect.left - baseRect.left;
      top = boundingRect.top - baseRect.top;
      width = boundingRect.right - boundingRect.left;
      height = boundingRect.bottom - boundingRect.top;
    }
    return {
      found,
      left,
      top,
      width,
      height,
      right: left + width,
      bottom: top + height
    };
  }

  $(() => {
    $(document).trigger('enhance');
  });

  document.addEventListener('DOMContentLoaded', () => {
    $('.nav-pills a').on('click', (e) => {
      $('#tab-content').css({
        width: '100%'
      });
    });

      //handle popup close
      $('.js-offcanvas-close-details').click(function (e) {
        e.preventDefault();
        $(this).closest('.js-offcanvas').find('.nav-link, .tab-pane').removeClass('active show');
        $(this).closest('.js-offcanvas').find('.tab-content').attr('style', '');
        return false;
      });

  });


  if ($('.homepage').length) {
    // trigger enhance for js-offcanvas menu
 

    // force the scroll to top on page reload
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };


    document.addEventListener('DOMContentLoaded', () => {
      const g = new Global();
      g.init();
      // show nav pills content


      function appenLeadingZeroToNumber(num) {
        if (num.toString().length == 1) {
          return `0${num}`.slice(-2);
        } else {
          return num;
        }
      }

      function renderHTML (days, hours, minutes, seconds) {
        document.getElementById('countdown').innerHTML = `<div class="countdown-item days"><span class="num">${appenLeadingZeroToNumber(days)}</span></div><div class="countdown-item hours"><span class="num">${appenLeadingZeroToNumber(hours)}</span></div><div class="countdown-item minutes"><span class="num">${appenLeadingZeroToNumber(minutes)}</span></div><div class="countdown-item seconds"><span class="num">${appenLeadingZeroToNumber(seconds)}</span></div>`;

        const isArabic = $("html").attr("dir") == 'rtl';
        const dayLabel = isArabic ? 'يوم' : 'day';
        const hourLabel = isArabic ? 'ساعة' : 'hour';
        const minuteLabel = isArabic ? 'دقيقة' : 'minute';
        const secondLabel = isArabic ? 'ثانية' : 'second';

        const daysLabel = isArabic ? 'أيام' : 'days';
        const hoursLabel = isArabic ? 'ساعات' : 'hours';
        const minutesLabel = isArabic ? 'دقيقة' : 'minutes';
        const secondsLabel = isArabic ? 'ثانية' : 'seconds';

        if (days === 0 || days > 1) {
          $('#countdown .days').append('<span>'+ daysLabel +'</span>');
        } else {
          $('#countdown .days').append('<span>'+ dayLabel +'</span>');
        }

        if (hours === 0 || hours > 1) {
          $('#countdown .hours').append('<span>'+ hoursLabel +'</span>');
        } else {
          $('#countdown .hours').append('<span>'+ hourLabel +'</span>');
        }

        if (minutes === 0 || minutes > 1) {
          $('#countdown .minutes').append('<span>'+ minutesLabel +'</span>');
        } else {
          $('#countdown .minutes').append('<span>'+ minuteLabel +'</span>');
        }

        if (seconds === 0 || seconds > 1) {
          $('#countdown .seconds').append('<span>'+ secondsLabel +'</span>');
        } else {
          $('#countdown .seconds').append('<span>'+ secondLabel +'</span>');
        }
      }

      // Update the countdown every 1 second
      const countdownfunction = setInterval(() => {
        if ($('#countdown').length == 0) {
          return;
        }

        const selectedDate = $('#countdown').data('time');
        const now = new Date().getTime();
        const countDownDate = new Date(selectedDate).getTime();

        // Find the distance between now an the count down date
        const distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        renderHTML(days, hours, minutes, seconds);

        // If the count down is over, write some text
        if (distance <= 1000) {
          clearInterval(countdownfunction);
          renderHTML(0, 0, 0, 0);
        }
      }, 1000);
    });

    let isBackend = ($('body[data-backend]').length > 0);

    const animData = {
      wrapper: document.getElementById('svg-animation-container'),
      animType: 'svg',
      progressiveLoad: true,
      loop: false,
      prerender: true,
      autoplay: false,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMin slice'
      },
      path: document.documentElement.lang === 'en' ? '/ResourcePackages/Theme/assets/dist/animation/data.en.json' : '/ResourcePackages/Theme/assets/dist/animation/data.ar.json'
    };

    if (!isBackend) {
      animData.path = document.documentElement.lang === 'en' ? '../animation/data.en.json' : '../animation/data.ar.json';
    }

    const animationControl = bodymovin.loadAnimation(animData);
    let initialImage;
    let deviceImage;
    let whiteBox;
    let redBox;
    let animationFrame;

    const initialAutoplayFrameEnd = 257;
    const lateAutoplayFrameStart = 530;
    let totalAnimationFrames = 0;
    let scrollWindow = 0;
    let hasLateAnimationStarted = false;
    let isSectionBoxesRendered = false;
    let isSectionImpactRendered = false;

    window.animationControl = animationControl; // eslint-disable-line

    animationControl.addEventListener('complete', () => {
      $('.svg-animation-end-text').addClass('animated fadeInUp');
    });

    animationControl.addEventListener('DOMLoaded', () => {
      // show rest of the page
      $('.section-challenge-info').css({
        display: 'block',
        opacity: 1
      });

      initialImage = $("svg image[*|href$='img_45.png']")[0];
      deviceImage = $("svg image[*|href$='img_38.png']")[0];
      whiteBox = $('.shadow-boxes .white-box')[0];
      redBox = $('.shadow-boxes .red-box')[0];

      //IE11 fix
      if (deviceImage == null) {
        deviceImage = document.querySelector("#svg-animation-container > svg > g > g:nth-child(12) > image");
      }
      if (initialImage == null) {
        initialImage = document.querySelector("#svg-animation-container > svg > g > g:nth-child(4) > image");
      }

      // override predefined background for the svg
      $('svg rect').css('fill', 'transparent');

      totalAnimationFrames = animationControl.totalFrames;
      animationControl.playSegments([
        [0, initialAutoplayFrameEnd]
      ], false);
      animationControl.setSpeed(2);

      // The scroll position where the rest of the animation will be triggered to automatically play
      scrollWindow = $('header').outerHeight() + $('#svg-animation-container > svg').outerHeight() - screen.availHeight;

      function animatebodymovin() {
        const scrollPosition = $(window).scrollTop();
        const percentPosition = scrollPosition / scrollWindow;
        const frame = initialAutoplayFrameEnd + ((lateAutoplayFrameStart - initialAutoplayFrameEnd) * percentPosition);

        if (percentPosition <= 1) {
          animationControl.playSegments([
            [0, lateAutoplayFrameStart - 1]
          ], false);
          animationControl.setSpeed(2);
          animationControl.goToAndStop(frame, true);
          hasLateAnimationStarted = false;
          $('.svg-animation-end-text').removeClass('animated fadeInUp');
        } else if (!hasLateAnimationStarted) {
          hasLateAnimationStarted = true;
          animationControl.playSegments([
            [lateAutoplayFrameStart, totalAnimationFrames - 1]
          ], false);
          animationControl.setSpeed(4);

          // TODO: Refactor this. Mayge this can be solved using CSS
          // position texts inside white and red boxes
          const translate = 'translate(-50%, -50%)';
          const whiteLeft = svgToScreen(whiteBox).left + svgToScreen(whiteBox).width / 2;
          $('.white-box--content').css({
            position: 'absolute',
            top: 0,
            left: whiteLeft,
            transform: translate,
            'max-width': svgToScreen(whiteBox).width
          });

          const redLeft = svgToScreen(redBox).left + svgToScreen(redBox).width / 2;
          $('.red-box--content').css({
            position: 'absolute',
            top: 0,
            left: redLeft,
            transform: translate,
            'max-width': svgToScreen(redBox).width
          });
        }

        if (!isSectionBoxesRendered && percentPosition >= 0.28) {
          isSectionBoxesRendered = true;
          $('.section-boxes').css({
            position: 'absolute',
            left: `${2}em`,
            top: svgToScreen(initialImage).bottom,
            width: `${50}%`
          });
          $('.section-boxes').addClass('animated fadeInUp');
          $('.section-boxes').css({
            display: 'block'
          });
        }
        if (!isSectionImpactRendered && percentPosition >= 0.58) {
          isSectionImpactRendered = true;
          $('.section-impact').css({
            position: 'absolute',
            right: `${3}em`,
            left: svgToScreen(deviceImage).left + 70,
            top: svgToScreen(deviceImage).bottom + ($(window).width() > 767 ? 200 : 0),
            'max-width': `${($(window).width() > 767 ? 50 : 60)}%`
          });
          $('.section-impact').addClass('animated fadeInUp');
          $('.section-impact').css({
            display: 'block'
          });
        }
      }


      // track scroll position
      $(window).scroll(() => {
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
          animationFrame = null;
        }
        if (typeof window.requestAnimationFrame === "function") {
          animationFrame = requestAnimationFrame(animatebodymovin);
        }
      });
    });

    $(window).on('resize', () => {
      // $('#countdown').css({
      //   position: 'absolute',
      //   top: `calc(${svgToScreen(initialImage).bottom}px - 100px)`
      // });
      // // $('#countdown').addClass('animated fadeInUp');
      // $('#countdown').css({
      //   display: 'flex'
      // });

      // position texts inside white and red boxes
      const translate = 'translate(-50%, -50%)';
      const whiteLeft = svgToScreen(whiteBox).left + svgToScreen(whiteBox).width / 2;
      $('.white-box--content').css({
        position: 'absolute',
        top: 0,
        left: whiteLeft,
        transform: translate,
        'max-width': svgToScreen(whiteBox).width
      });

      const redLeft = svgToScreen(redBox).left + svgToScreen(redBox).width / 2;
      $('.red-box--content').css({
        position: 'absolute',
        top: 0,
        left: redLeft,
        transform: translate,
        'max-width': svgToScreen(redBox).width
      });
    });
  }
};
